import { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { ArrowLeftShort } from "react-bootstrap-icons";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Card,
} from "react-bootstrap";
import { getData } from "country-list";
import ReceiptDownloadButton from "./ReceiptDownloadButton";

export default function ProfileEditPage() {
  const { currentUser, updateProfile } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(currentUser.profile || {});

  const allCountries = getData().sort((a, b) => a.name.localeCompare(b.name));
  const otherCountries = allCountries.filter(
    (c) => c.code !== "US" && c.code !== "CA"
  );

  const allStates = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'DC', label: 'District Of Columbia' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VI', label: 'Virgin Islands' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
];

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateProfile(formData);
      navigate("/");
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (currentUser?.profile) {
      setFormData(currentUser.profile);
    }
  }, [currentUser]);

  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col md={10}>

          <div className="d-flex justify-content-between mb-3">
            <Button className="purple-button" onClick={() => {
              navigate("/");
            }}>
              <ArrowLeftShort fontSize="1.5rem" />Home
            </Button>
            <ReceiptDownloadButton />
          </div>

          <Card>
            <Card.Header as="h5">Edit Your Profile</Card.Header>
            <Card.Body>
              <Card.Text>
                {Object.keys(formData).length === 0 ? "Thank you for your payment." : ""} Please update your profile details with any changes since you registered for TF-CBTWeb 2.0.
              </Card.Text>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <p className="ml-2">This is the name that will appear on your course certificate.</p>
                </Row>
                <Row classname="mb-3 border rounded-2 bg-light mx-2">
                  <Col md={5}>
                    <Form.Group className="mb-3" controlId="formFirstName">
                      <Form.Label className="small">First Name</Form.Label>
                      <Form.Control
                        name="first_name"
                        value={formData.first_name || ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group className="mb-3" controlId="formMiddleInitial">
                      <Form.Label className="small">Middle Initial</Form.Label>
                      <Form.Control
                        name="middle_initial"
                        value={formData.middle_initial || ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <Form.Group className="mb-3" controlId="formLastName">
                      <Form.Label className="small">Last Name</Form.Label>
                      <Form.Control
                        name="last_name"
                        value={formData.last_name || ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group
                      className="mb-3"
                      controlId="formWorkSchoolAffiliation"
                    >
                      <Form.Label className="small">
                        Work or school affiliation
                      </Form.Label>
                      <Form.Control
                        name="work_school_affiliation"
                        value={formData.work_school_affiliation || ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formTitle">
                      <Form.Label className="small">Position Title</Form.Label>
                      <Form.Control
                        name="title"
                        value={formData.title || ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formProfession">
                      <Form.Label className="small">Profession</Form.Label>
                      <Form.Select
                        name="profession"
                        value={formData.profession || ""}
                        onChange={handleChange}
                      >
                        <option value="">Select your profession</option>
                        <option value="psychology">Psychology</option>
                        <option value="social_work">Social Work</option>
                        <option value="counseling">Counseling</option>
                        <option value="marriage/family">Marriage/Family</option>
                        <option value="nursing">Nursing</option>
                        <option value="psychiatry">Psychiatry</option>
                        <option value="other">Other</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    {formData.profession === "other" && (
                      <Form.Group
                        className="mb-3"
                        controlId="formOtherProfession"
                      >
                        <Form.Label className="small">
                          Please specify your profession
                        </Form.Label>
                        <Form.Control
                          name="other_profession"
                          value={formData.other_profession || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formDegree">
                      <Form.Label className="small">Degree</Form.Label>
                      <Form.Select
                        name="degree"
                        value={formData.degree || ""}
                        onChange={handleChange}
                      >
                        <option value="">Select your degree</option>
                        <option value="pre_masters_student">
                          Pre-masters student
                        </option>
                        <option value="masters">Masters</option>
                        <option value="doctorate">Doctorate</option>
                        <option value="medical_degree">Medical Degree</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group
                      className="mb-3"
                      controlId="formYearsOfExperience"
                    >
                      <Form.Label className="small">
                        Years of experience
                      </Form.Label>
                      <Form.Select
                        name="years_of_experience"
                        value={formData.years_of_experience || ""}
                        onChange={handleChange}
                      >
                        <option value="">
                          Select your years of experience
                        </option>
                        <option value="<5">&lt;5</option>
                        <option value="5-10">5-10</option>
                        <option value="10-20">10-20</option>
                        <option value="20+">20+</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <Form.Group className="mb-3" controlId="formGender">
                      <Form.Label className="small">Gender</Form.Label>
                      <Form.Select
                        name="gender"
                        value={formData.gender || ""}
                        onChange={handleChange}
                      >
                        <option value="">Select your gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Not Specified">Not Specified</option>
                        <option value="Other">Other</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-3" controlId="formCountry">
                      <Form.Label className="small">Country</Form.Label>
                      <Form.Select
                        name="country"
                        value={formData.country || ""}
                        onChange={handleChange}
                      >
                        <option value="">Select your country</option>
                        <option value="US">United States</option>
                        <option value="CA">Canada</option>
                        {otherCountries.map((country) => (
                          <option key={country.code} value={country.code}>
                            {country.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    {formData.country === "US" && (
                      <Form.Group
                        className="mb-3"
                        controlId="formState"
                      >
                        <Form.Label className="small">
                          State
                        </Form.Label>
                        <Form.Select
                          name="state"
                          value={formData.state || ""}
                          onChange={handleChange}
                        >
                          <option value="">Select your state</option>
                          {allStates.map((state) => (
                            <option key={state.value} value={state.value}>
                              {state.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    )}
                  </Col>
                </Row>

                <div className="d-grid">
                  <Button className="purple-button" type="submit">
                    Save Profile
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
